let urlSuffix = "";
axios.interceptors.request.use((config) => {
  config.headers['Content-Type'] = 'application/json; charset=UTF-8';
  config.headers['Accept'] = 'application/json';
  config.headers['Access-Control-Allow-Origin'] = '*';

  if ( urlSuffix.length > 0 && config.url.indexOf(urlSuffix) === -1 ) {
      if(config.url.substring(config.url.length-5) != ".json") {
          let urlparts= config.url.split('?');
          config.url = urlparts[0] + urlSuffix + (urlparts[1]===undefined?'':'?'+urlparts[1]);
      }
  }
  return config;
}, error => {
  console.log("Failed sending request!");
  return Promise.reject(error);
});
